import { Navigate, Outlet } from "react-router-dom";

const PublicRoute = () => {
  const token = localStorage.getItem("spektorAdminUser");

  return token ? <Navigate to="/" /> : <Outlet />;
};

export default PublicRoute;
